var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMalaysia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3037 16.0001H31.9993C31.9993 14.5559 31.8068 13.157 31.4481 11.8262H15.3037V16.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3037 7.65221H29.651C28.6715 6.05396 27.4193 4.64127 25.9591 3.47827H15.3037V7.65221Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32C19.7654 32 23.2265 30.6985 25.9597 28.5217H6.04004C8.77323 30.6985 12.2343 32 15.9999 32Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34797 24.3478H29.6512C30.4375 23.0648 31.0473 21.6622 31.4484 20.1738H0.550781C0.951844 21.6622 1.56166 23.0648 2.34797 24.3478Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16C16 7.1635 16 6.12175 16 0C7.1635 0 0 7.1635 0 16H16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6394 13.6956C8.45423 13.6956 6.68286 11.9242 6.68286 9.73913C6.68286 7.55407 8.4543 5.78263 10.6394 5.78263C11.3207 5.78263 11.9617 5.95494 12.5214 6.25819C11.6434 5.39963 10.4427 4.86963 9.11761 4.86963C6.4283 4.86963 4.24805 7.04982 4.24805 9.73919C4.24805 12.4286 6.4283 14.6088 9.11761 14.6088C10.4427 14.6088 11.6434 14.0788 12.5214 13.2202C11.9617 13.5233 11.3207 13.6956 10.6394 13.6956Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7546 6.95654L12.4571 8.42542L14.0434 8.05892L13.333 9.52386L14.6088 10.5355L13.0204 10.8936L13.0248 12.5218L11.7546 11.5032L10.4844 12.5218L10.4888 10.8936L8.90039 10.5355L10.1761 9.52386L9.4657 8.05892L11.0521 8.42542L11.7546 6.95654Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMalaysia);
export default __webpack_public_path__ + "static/media/flag_malaysia.c8b61e8258c595833d1d9cb6dad41855.svg";
export { ForwardRef as ReactComponent };